export function addressSplitter(adresnyString: string) {
  const cleanString = adresnyString.trim()
  const lastCommaIndex = cleanString.lastIndexOf(',')

  if (lastCommaIndex === -1) {
    return {
      adress: cleanString,
      city: '',
    }
  }

  const adress = cleanString.substring(0, lastCommaIndex).trim()
  const city = cleanString.substring(lastCommaIndex + 1).trim()

  return {
    adress,
    city,
  }
}
